// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2WgX4","label":"Category_label__Dj3j0","content":"Category_content__2lNa4","header":"Category_header__3yJ5r","location":"Category_location__U0BfW"};